import { useQuery } from '@tanstack/react-query';

import { DrugsApi } from '@/api/domains/drugs.api';
import { DrugsQueryKeys } from '@/api/domains/drugs.query-keys';
import type { ReceptionFeature } from '@/api/domains/drugs.types';

const defaultItems: ReceptionFeature[] = [];

export const useNomenclatureReceptionFeatures = (drugId?: number) => {
  const { data, isFetching: isReceptionFeaturesFetching } = useQuery({
    queryKey: DrugsQueryKeys.receptionFeatures(drugId),
    queryFn: () => {
      if (drugId) {
        return DrugsApi.fetchReceptionFeatures(drugId);
      }
    },
    staleTime: Infinity,
  });

  const receptionFeatures = data?.items ?? defaultItems;

  return { receptionFeatures, isReceptionFeaturesFetching };
};
